import { Typography } from '@automata/ui';
import Box from '@mui/material/Box';
import { Position } from 'reactflow';

import { SOURCE_HANDLE_IDENTIFIER } from '../../../../constants';
import {
  getColorFromIndex,
  serializeLabwareHandlePairId,
} from '../../../../utils';
import Handle from '../../Handle';

export type Props = {
  color: number | boolean;
  handlePairId: string;
  label: string;
};

const ConditionLabwareSection = ({ handlePairId, label, color }: Props) => {
  const borderColor =
    typeof color === 'number' ? getColorFromIndex(color) : 'black';

  return (
    <Box position="relative" sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
      <Typography
        color="white"
        variant="h6"
        textAlign="center"
        padding="0.25rem 0.75rem"
        noWrap
      >
        {label}
      </Typography>
      <Handle
        id={serializeLabwareHandlePairId(
          SOURCE_HANDLE_IDENTIFIER,
          handlePairId
        )}
        type="source"
        position={Position.Bottom}
        style={{
          borderColor,
          bottom: -25,
        }}
      />
    </Box>
  );
};

export default ConditionLabwareSection;
